import { motion } from 'motion/react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SlideDownArrowProps {
  onClick: () => void;
  variant?: 'light' | 'dark';
  label?: string;
  className?: string;
}

export function SlideDownArrow({
  onClick,
  variant = 'light',
  label = 'Continue',
  className,
}: SlideDownArrowProps) {
  const colorClasses = variant === 'light'
    ? 'text-white/70 hover:text-white'
    : 'text-eventus-navy/70 hover:text-eventus-navy';

  return (
    <motion.button
      onClick={onClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1, duration: 0.8 }}
      className={cn(
        'absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 transition-colors cursor-pointer z-10',
        colorClasses,
        className
      )}
      aria-label={label}
    >
      <span className="text-sm font-medium uppercase tracking-wider">{label}</span>
      <motion.span
        animate={{ y: [0, 8, 0] }}
        transition={{ repeat: Infinity, duration: 1.5, ease: 'easeInOut' }}
      >
        <ChevronDown className="w-6 h-6" />
      </motion.span>
    </motion.button>
  );
}
